// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jsnI","colBig":"styles_colBig__AMaHr","colSmall":"styles_colSmall__12kcr"};